import { Link } from 'react-router-dom';

export default function FeaturedContent() {
  const featuredItems = [
    {
      category: "Hospitality",
      title: "VIP対応の極意",
      description: "一流ホテルで培ったVIPゲスト対応の真髄。期待を超えるサービスの秘訣とは。心に残る特別な体験を創造する技術をご紹介します。",
      image: "/images/generated/seq-vip-service-a0ca35.jpg",
      link: "/wisdom/hospitality"
    },
    {
      category: "Etiquette", 
      title: "テーブルマナーの美学",
      description: "フォーマルディナーで輝く、品格あるテーブルマナー。基本から応用まで、社交の場で自信を持てる洗練された所作をお教えします。",
      image: "/images/generated/seq-table-manner-cad0af.jpg",
      link: "/wisdom/etiquette"
    },
    {
      category: "Butler Life",
      title: "執事の一日", 
      description: "朝の準備から夜の片付けまで。執事の日常に秘められたプロフェッショナリズム。完璧なサービスを支える哲学と実践をご覧ください。",
      image: "/images/generated/seq-butler-daily-22a08d.jpg",
      link: "/wisdom/butler-skills"
    }
  ];

  return (
    <section className="py-32 bg-gray-50 relative overflow-hidden">
      {/* Subtle background elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 left-10 w-40 h-40 border border-amber-400 rounded-full"></div>
        <div className="absolute bottom-1/4 right-10 w-32 h-32 border border-amber-400 rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center mb-8">
            <div className="w-20 h-px bg-amber-400"></div>
            <span 
              className="mx-8 text-amber-600 text-sm tracking-[0.3em] font-light uppercase"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              Featured Contents
            </span>
            <div className="w-20 h-px bg-amber-400"></div>
          </div>
          
          <h2 
            className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-wide"
            style={{ 
              fontFamily: '"Noto Serif JP", serif',
              letterSpacing: '0.02em'
            }}
          >
            執事の世界へようこそ
          </h2>
          
          <p 
            className="text-xl text-gray-600 font-light max-w-6xl mx-auto leading-relaxed"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.8'
            }}
          >
            一流のおもてなしの世界を深く知る、特別なコンテンツをご用意いたしました
          </p>
        </div>

        {/* Featured Cards Grid */}
        <div className="grid md:grid-cols-3 gap-10">
          {featuredItems.map((item, index) => (
            <article 
              key={index}
              className="group relative bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-700 transform hover:-translate-y-2"
            >
              <Link to={item.link} className="block">
                {/* Image Container */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  
                  {/* Elegant overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  {/* Category badge */}
                  <div className="absolute top-4 left-4">
                    <span 
                      className="inline-block bg-amber-400/90 text-black px-5 sm:px-6 lg:px-8 py-2 text-xs tracking-[0.2em] font-medium uppercase backdrop-blur-sm"
                      style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                    >
                      {item.category}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8">
                  <h3 
                    className="text-2xl font-light text-gray-900 mb-4 group-hover:text-amber-600 transition-colors duration-300"
                    style={{ 
                      fontFamily: '"Noto Serif JP", serif',
                      letterSpacing: '0.02em'
                    }}
                  >
                    {item.title}
                  </h3>
                  
                  <p 
                    className="text-gray-600 leading-relaxed font-light mb-6"
                    style={{ 
                      fontFamily: '"Noto Sans JP", sans-serif',
                      lineHeight: '1.8'
                    }}
                  >
                    {item.description}
                  </p>
                  
                  {/* Read More Link */}
                  <div className="flex items-center text-amber-600 group-hover:text-amber-700 transition-colors duration-300">
                    <span 
                      className="font-light tracking-wide mr-2"
                      style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                    >
                      Read More
                    </span>
                    <i className="ri-arrow-right-line text-lg transform group-hover:translate-x-2 transition-transform duration-300"></i>
                  </div>
                </div>

                {/* Decorative corner elements */}
                <div className="absolute top-0 left-0 w-8 h-8 border-l-2 border-t-2 border-amber-400/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <div className="absolute bottom-0 right-0 w-8 h-8 border-r-2 border-b-2 border-amber-400/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </Link>
            </article>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-16">
          <Link
            to="/wisdom"
            className="group relative inline-flex items-center bg-amber-700 text-white hover:bg-amber-800 px-12 py-4 font-light text-lg transition-all duration-500 overflow-hidden whitespace-nowrap"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              letterSpacing: '0.1em'
            }}
          >
            <span className="relative z-10 mr-3">View All Contents</span>
            <i className="ri-arrow-right-line relative z-10 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            
            {/* Hover effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
          </Link>
        </div>
      </div>
    </section>
  );
}
